export var initData = function (length, value) {
    if (value === void 0) { value = false; }
    return Array.from({ length: length }).map(function () { return ({ value: value ? 1 : 0 }); });
};
